const ROLE_IDS = {
  ADMIN: 1,
  BUYER: 2,
  DISTRIBUTOR: 3,
  SELLER: 4,
};

export default ROLE_IDS;
